module.exports = __webpack_public_path__ + "img/become-owner-illu.3238f9bd.jpg";